import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RibbonTagComponent from '../../RibbonTagComponent';

import { htmlSanitizer } from '../../../lib/helpers';
import CompleteIcon from '../../TileComponent/CompleteIcon';
import { FullImage } from '../StyledComponents';
import ImageCredit from './ImageCredit';

const determineIfMarkedComplete = (tileOrigin, tileComplete) =>
  tileOrigin === 'complete' || tileComplete ? 'completed' : 'not_completed';

const calculatedHeight = source => {
  if (source === 'image') {
    const image = document.getElementById('tile_img_preview');
    return `${image.offsetHeight / 2 + 8}px`;
  }
  if (source === 'video') {
    const image = document.querySelector('.video_section');
    return `${image.offsetHeight / 2 + 8}px`;
  }
  return '110px';
};

const TileImageComponent = ({ tileOrigin, tile, setImageTop }) => {
  useEffect(() => {
    if (tile.embedVideo) {
      setImageTop(calculatedHeight('video'));
    }
  }, [setImageTop, tile.embedVideo]);
  return (
    <div>
      {determineIfMarkedComplete(tileOrigin, tile.complete) === 'completed' && (
        <CompleteIcon />
      )}

      {tile.embedVideo ? (
        <div className="video_section" style={{ display: 'block' }}>
          <Video dangerouslySetInnerHTML={htmlSanitizer(tile.embedVideo)} />
          {tile.ribbonTagName && (
            <RibbonTagComponent
              ribbonTagName={tile.ribbonTagName}
              ribbonTagColor={tile.ribbonTagColor}
              height="44"
              hideRibbonTag="true"
              fullSizeTile={true}
              hideOnHover={true}
            />
          )}
        </div>
      ) : (
        <div className="image_section">
          <FullImage>
            <Image
              src={tile.imagePath}
              id="tile_img_preview"
              alt={tile.headline}
              onLoad={() => setImageTop(calculatedHeight('image'))}
            />
            <div className="shadow_overlay non-landing"></div>
            {tile.imageCredit && (
              <ImageCredit
                imageCredit={tile.imageCredit}
                mediaSource={tile.mediaSource}
              />
            )}
            {tile.ribbonTagName && (
              <RibbonTagComponent
                ribbonTagName={tile.ribbonTagName}
                ribbonTagColor={tile.ribbonTagColor}
                height="44"
                fullSizeTile={true}
              />
            )}
          </FullImage>
        </div>
      )}
      <div id="tileGrayOverlay" style={{ display: 'none' }}></div>
    </div>
  );
};

TileImageComponent.propTypes = {
  tileOrigin: PropTypes.string,
  tile: PropTypes.shape({
    embedVideo: PropTypes.string,
    imagePath: PropTypes.string,
    headline: PropTypes.string,
    imageCredit: PropTypes.string,
    ribbonTagName: PropTypes.string,
    ribbonTagColor: PropTypes.string,
    setImageTop: PropTypes.bool,
    complete: PropTypes.bool,
  }),
  setImageTop: PropTypes.func,
};

export default TileImageComponent;

const Image = styled.img`
  width: 100%;
  min-height: 100px;
  max-height: 500px;
  object-fit: cover;
  opacity: 1;
  transition: all 0.5s;
  background: white;
`;

const Video = styled.span`
  iframe:hover {
    z-index: 10;
  }
`;
